<template>
  <BaseListItem v-if="edit">
    <div class="flex items-baseline -mx-2">
      <div class="flex-1 px-2 space-y-2">
        <ValidationProvider
          name="businessName"
          :vid="`registrations.${index}.businessName`"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              v-model.lazy="businessName"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter business name..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="businessType"
          :vid="`registrations.${index}.businessType`"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              v-model.lazy="businessType"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter business type..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="flex flex-col gap-2 self-stretch items-stretch flex-1 px-2">
        <ValidationProvider
          name="businessCountry"
          :vid="`registrations.${index}.businessCountry`"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormSelect
              v-model="businessCountry"
              :disabled="updating"
              default-option-label="Επιλέξτε χώρα"
              :options="[
                { value: 'GR', label: 'Ελλάδα' },
                { value: 'CY', label: 'Κύπρος' },
                { value: 'GB', label: 'Αγγλία' },
              ]"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
        <ValidationProvider
          name="businessAddress"
          :vid="`registrations.${index}.businessAddress`"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormTextarea
              v-model.lazy="businessAddress"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter business address..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="flex-1 px-2 space-y-2">
        <ValidationProvider
          name="number"
          :vid="`registrations.${index}.number`"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              v-model.lazy="number"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter number..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="office"
          :vid="`registrations.${index}.office`"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              v-model.lazy="office"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter office..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="vatRate"
          :vid="`registrations.${index}.vatRate`"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              type="number"
              min="0"
              max="100"
              v-model.lazy="vatRate"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter vat rate..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="pr-2">
        <BaseIconButton v-if="!updating" icon="trash" brand @click="$emit('destroy')" />
        <Loader v-else small />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else-if="updating">
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 text-red-500 text-center">
        <Loader medium />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else>
    <div class="flex items-baseline -mx-2">
      <div class="flex-1 px-2 truncate">
        <ul>
          <li>{{ entity.businessName }}</li>
          <li class="text-sm capitalize text-gray-700">
            {{ entity.businessType }}
          </li>
        </ul>
      </div>
      <div class="flex-1 flex flex-col px-2 truncate">
        <span>{{ entity.businessAddress }}, {{ entity.businessCountry }}</span>
      </div>
      <div class="flex-1 px-2 truncate">
        <ul>
          <li>{{ entity.number }}</li>
          <li class="text-sm capitalize text-gray-700">
            {{ entity.office }}
          </li>
          <li class="text-sm capitalize text-gray-700">Συντελεστής ΦΠΑ: {{ entity.vatRate }}</li>
        </ul>
      </div>
      <div class="pr-2">
        <div class="w-10" />
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  name: 'ListingItem',
  props: {
    index: {
      type: Number,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    edit: Boolean,
    updating: Boolean,
  },
  computed: {
    businessName: {
      get() {
        return this.entity.businessName;
      },
      set(businessName) {
        this.$emit('change', { ...this.entity, businessName });
      },
    },
    businessType: {
      get() {
        return this.entity.businessType;
      },
      set(businessType) {
        this.$emit('change', { ...this.entity, businessType });
      },
    },
    businessCountry: {
      get() {
        return this.entity.businessCountry;
      },
      set(businessCountry) {
        this.$emit('change', { ...this.entity, businessCountry });
      },
    },
    businessAddress: {
      get() {
        return this.entity.businessAddress;
      },
      set(businessAddress) {
        this.$emit('change', { ...this.entity, businessAddress });
      },
    },
    number: {
      get() {
        return this.entity.number;
      },
      set(number) {
        this.$emit('change', { ...this.entity, number });
      },
    },
    office: {
      get() {
        return this.entity.office;
      },
      set(office) {
        this.$emit('change', { ...this.entity, office });
      },
    },
    vatRate: {
      get() {
        return this.entity.vatRate;
      },
      set(vatRate) {
        this.$emit('change', { ...this.entity, vatRate });
      },
    },
  },
};
</script>
